<template>
  <div
    class="sidebar-logo-container"
    :class="{ collapse: collapse }"
    :style="{
            backgroundColor: sideTheme === 'theme-dark' ? '#304156' : '#ffffff',
        }"
  >
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link flex align_center justify_center" to="/">
        <!-- <img v-if="logo" :src="logo" class="sidebar-logo" />
        <h1 v-else class="sidebar-title" :style="{ color: sideTheme === 'theme-dark' ? variables.logoTitleColor : variables.logoLightTitleColor }">{{ title }}</h1> -->
        <img src="@/assets/logo/logo.png" class="w-160 h-36" alt="" srcset=""/>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link flex align_center justify_center" to="/">
        <!-- <img v-if="logo" :src="logo" class="sidebar-logo" /> -->
        <!-- <span class="sidebar-title" :style="{ color: sideTheme === 'theme-dark' ? variables.logoTitleColor : variables.logoLightTitleColor }">{{ title }}</span> -->
        <img src="@/assets/logo/logo.png" class="w-160 h-36" alt="" srcset=""/>
      </router-link>
    </transition>
  </div>
</template>

<script>
import logoImg from '@/assets/logo/logo.gif';
import variables from '@/assets/styles/variables.scss';

export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    variables(){
      return variables;
    },
    sideTheme(){
      return this.$store.state.settings.sideTheme;
    },
  },
  data(){
    return {
      title: '物联网平台',
      logo: logoImg,
    };
  },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 208px;
  height: 50px;
  line-height: 50px;
  // background: #2b2f3a;
  overflow: hidden;
  border-right: 1px solid #eeeeee;
  // margin-left: 15px;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 400;
      line-height: 50px;
      font-size: 20px;
      font-family: '微软雅黑';
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
